import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from 'rebass/styled-components';
import styled from 'styled-components';
import theme from 'styled-theming';
import EditorJSON from './Editor/EditorJSON';

const textColor = theme('mode', {
  light: (props) => props.theme.colors.deepGrey,
  dark: (props) => props.theme.colors.white,
});

const Name = styled(Box)`
  color: ${textColor};
`;

const sortObject = (obj, type) => {
  const outputObj = {};
  switch (type) {
    case 'faas':
    case 'static':
      // Only allow name editing if the item is in temporary mode
      if (obj.isTemporary) {
        outputObj.name = obj.name;
      }
      outputObj.payload = obj.payload;
      break;
    default:
      if (obj.name) {
        outputObj.name = obj.name;
      }
      if (obj.conditions) {
        outputObj.conditions = obj.conditions;
      }
      if (obj.actions) {
        outputObj.actions = obj.actions;
      }
      if (obj.exception) {
        outputObj.exception = obj.exception;
      }
  }

  return outputObj;
};

function JSONEditor(props) {
  const {
    selectedObject, selectedString, handleChange, isEditing,
  } = props;

  const {
    order,
    id,
    enabled,
    schemaVersion,
    accountId,
    ...cleanedObject
  } = selectedObject;

  const sortedObject = sortObject(cleanedObject, selectedObject.type);

  return (
    <Box m={3}>
      <Flex alignItems="center" mb={3}>
        <Name fontSize={2} mr={2} data-testid="editor-name">
          {selectedObject.name}
        </Name>
      </Flex>
      <EditorJSON
        isEditing={isEditing}
        jsonObject={sortedObject}
        jsonString={selectedString}
        handleChange={handleChange}
      />
    </Box>
  );
}

JSONEditor.defaultProps = {
  isEditing: false,
  handleChange: undefined,
};

JSONEditor.propTypes = {
  isEditing: PropTypes.bool,
  selectedObject: PropTypes.object.isRequired,
  selectedString: PropTypes.string.isRequired,
  handleChange: PropTypes.func,
};

export default JSONEditor;
